'use strict';

function CreditScoreTabs() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  // The default page priority is at 2000.
  // the lower the value, the higher the priority
  // we want this top tray to load before the page
  this.priority = 800;

  this.init = function () {
    this.tabItems = [{
      title: 'Overview',
      url: '/member/dashboard/credit-score',
      ariaControls: 'Overview',
      analyticsId: 'MogoMember-Navigation-Overview-Navigation-Component'
    }, {
      title: 'MoneyClass',
      url: '/member/dashboard/credit-score/educational',
      ariaControls: 'MoneyClass',
      analyticsId: 'MogoMember-Navigation-MoneyClass-Navigation-Component'
    }];

    $('#CreditScoreTabs').mogo().create('TabsNavigation', {
      tabs: this.tabItems
    });
  };

  this.initAllReady = function () {};

  this.destroy = function () {};
}